export default __webpack_public_path__ + "static/media/autonomy-colored.459e7d0c.svg";